import { HealthResponseSchema, type HealthResponse } from '@devlearn/shared';
import { api } from '@/lib/apiClient';

export const statusApi = {
  health: () => api<HealthResponse>('/health', { schema: HealthResponseSchema }),
};
